import { IMiningPlanOptions } from "@services/getMinerList";

export enum ActionTypesMiningPlansE {
  SET_MINING_PLANS = "SET_MINING_PLANS",
  UPDATE_PLAN = "UPDATE_PLAN",
  CLEAR_MINING_PLANS = "CLEAR_MINING_PLANS",
  ADD_PLAN = "ADD_PLAN",
  DELETE_PLAN = "DELETE_PLAN",
}

export interface ActionBaseMiningPlans {
  type: ActionTypesMiningPlansE;
}

export interface ActionSetMiningPlans extends ActionBaseMiningPlans {
  payload: {
    mining_plans: IMiningPlanOptions[];
  };
}

export interface ActionUpdateMiningPlan extends ActionBaseMiningPlans {
  payload: IMiningPlanOptions;
}

export interface ActionAddMiningPlan extends ActionBaseMiningPlans {
  payload: IMiningPlanOptions;
}

export interface ActionDeleteMiningPlan extends ActionBaseMiningPlans {
  payload: number;
}
